export default __webpack_public_path__ + "53ad353582c96ea550a7bb9c1fdc1fa0.svg";